import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import RequestRateLimitsTableRow, { formatUserForDisplay } from './RequestRateLimitsTableRow';
import './_styles_/RequestRateLimitsTable.css';
import { requestRateLimitsType } from '../../types';
import { getRequestType } from '../../utils/RequestTypes';
import Constants from '../../utils/Constants';

RequestRateLimitsTable.propTypes = {
    requestRateLimits: requestRateLimitsType.isRequired,
    onRequestRateLimitDelete: PropTypes.func.isRequired,
    onRequestRateLimitChange: PropTypes.func.isRequired,
    backendChanged: PropTypes.bool.isRequired,
    doReset: PropTypes.bool.isRequired,
};

export const requestRateLimitsSortFunc = (t) => (firstRateLimit, secondRateLimit) => {
    const firstUserForDisplay = formatUserForDisplay(t, firstRateLimit.user);
    const secondUserForDisplay = formatUserForDisplay(t, secondRateLimit.user);
    let result = firstUserForDisplay.localeCompare(secondUserForDisplay);
    if (result === 0) {
        result = getRequestType(firstRateLimit.requestType).translate(t).localeCompare(getRequestType(secondRateLimit.requestType).translate(t));
    }
    return result;
};

function RequestRateLimitsTable(props) {
    const {
        requestRateLimits,
        onRequestRateLimitDelete,
        onRequestRateLimitChange,
        backendChanged,
        doReset,
    } = props;
    const { t } = useTranslation();
    const sortedRequestRateLimits = [...requestRateLimits].sort(requestRateLimitsSortFunc(t));
    return (
        <div className="detail-list">
            <div className="detail-list-row detail-list-header">
                <div className="request-rate-limit-cell--small">&nbsp;</div>
                <div className="request-rate-limit-cell request-rate-limits-table-row--header--user">{t('settings.request-rates-and-limits.request-rate-limits.user')}</div>
                <div className="request-rate-limit-cell request-rate-limits-table-row--header--request-type">{t('settings.request-rates-and-limits.request-rate-limits.request-type')}</div>
                <div className="request-rate-limit-cell request-rate-limits-table-row--header--message-rate">{t('settings.request-rates-and-limits.request-rate-limits.message-rate')}</div>
                <div className="request-rate-limit-cell request-rate-limits-table-row--header--rate-limit">{t('settings.request-rates-and-limits.request-rate-limits.rate-limit')}</div>
            </div>
            {sortedRequestRateLimits.map((requestRateLimit) => (
                <RequestRateLimitsTableRow
                    key={`${requestRateLimit.user ? requestRateLimit.user.racf : Constants.ALL_USERS_OPTION_VALUE}-${requestRateLimit.requestType}`}
                    requestRateLimit={requestRateLimit}
                    onRequestRateLimitDelete={onRequestRateLimitDelete}
                    onRequestRateLimitValidated={onRequestRateLimitChange(requestRateLimit)}
                    backendChanged={backendChanged}
                    doReset={doReset}
                />
            ))}
        </div>
    );
}

export default RequestRateLimitsTable;
